import styled from 'styled-components';
import tw, { classnames, padding, borderRadius, display, space, alignItems, backgroundColor, textColor } from 'tailwindcss-classnames';

const classnameBase = classnames(padding('px-4', 'py-4'), borderRadius('rounded-md'), display('flex'), space('space-x-4'), alignItems('items-center'));

export const getContainer = (type: 'success'|'info') => type === 'success' ? SuccessContainer : InfoContainer

export const SuccessContainer = styled.div.attrs({
    className: classnames(classnameBase, backgroundColor('bg-green-100'), textColor('text-green-800'))
})``;

const InfoContainer = styled.div.attrs({
    className: classnames(classnameBase, backgroundColor('bg-blue-200'), textColor('text-blue-700'))
})``;